export default __webpack_public_path__ + "static/media/SX.5523d687.svg";